import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_02_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-02-01",
    "name": "训练前准备",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "general",
    "tips": ["训练前背阔肌放松与肩胛激活准备讲解", "按后续动作进行实际热身"],
    "sets": 1,
    "reps": "3分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/b934b7e239f007e2ff532344.mp4",
    "videoUrl": "/media/collections-20261008/videos/21bb66cda8cbe8188ba18ea7.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-02-02",
    "name": "健腹轮泡沫轴",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "core",
    "tips": ["跪姿持健腹轮或前臂搭泡沫轴向前伸展再回收", "保持核心稳定，作为背部训练前活动"],
    "sets": 1,
    "reps": "2分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": false,
    "isWarmup": true,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/3f3d5f9c35a2a320674cc48c.mp4",
    "videoUrl": "/media/collections-20261008/videos/84827a295e0b546b87eaa3f4.mp4",
    "targetMuscles": ["背阔肌", "核心肌群", "肩胛稳定肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-02-03",
    "name": "跪姿肘屈伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/1f563fcfaf143eb2a24d0561.mp4",
    "videoUrl": "/media/collections-20261008/videos/ee2f640686737ec4152f5b38.mp4",
    "source": "私教跟练 · 第2期",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-02-04",
    "name": "直臂下压",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lats",
    "tips": ["核心收紧，背部主导发力", "感受背阔肌延展与收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-37a43dd3acc01649a1fd1626.mp4",
    "videoUrl": "/media/collections-20261008/videos/096b5dac9a8a3140842717ba.mp4",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-02-05",
    "name": "单手绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lats",
    "tips": ["肩胛后收再拉肘", "每侧交替感受背阔肌收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/9b0ec8d73b4c06a95029fcfd.mp4",
    "videoUrl": "/media/collections-20261008/videos/e909f1f58bb8a39f0cbdea03.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-02-06",
    "name": "对握高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["拉至胸上沿", "挤压背阔肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-3a5abec75fbb5bf76d5266c0.mp4",
    "videoUrl": "/media/collections-20261008/videos/4cd0ccf1fda54578d854c807.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第2期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-02-07",
    "name": "坐姿绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "row",
    "tips": ["躯干保持稳定", "拉至小腹位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/192d4f6b15050ff57c80918a.mp4",
    "videoUrl": "/media/collections-20261008/videos/f7f9c1e2cdb7d2fd65651d52.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第2期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-02-08",
    "name": "绳索曲臂下压",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["大臂固定不晃动", "感受三头肌收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/9606cb8228bb3ed526c0a61c.mp4",
    "videoUrl": "/media/collections-20261008/videos/f9e8b2783eda7cc429a0d114.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-02-09",
    "name": "龙门架反向飞鸟",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-delt",
    "tips": ["俯身角度稳定", "感受后束挤压"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "私教跟练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/322e16e968af824a1759b124.mp4",
    "videoUrl": "/media/collections-20261008/videos/dcfa13916fb74e8d37e01266.mp4",
    "targetMuscles": ["三角肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
